import { createFileRoute } from '@tanstack/react-router';

import Companies from '@/modules/companies/pages/Companies';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/companies/',
)({
  head: () => ({
    meta: [{ title: 'Empresas' }],
  }),
  component: Companies,
});
